import { render, staticRenderFns } from "./Collaboration_form.vue?vue&type=template&id=e74637a8&scoped=true&"
import script from "./Collaboration_form.vue?vue&type=script&lang=js&"
export * from "./Collaboration_form.vue?vue&type=script&lang=js&"
import style0 from "./Collaboration_form.vue?vue&type=style&index=0&id=e74637a8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e74637a8",
  null
  
)

export default component.exports